import api from "./api";

const AuthService = {
  login: async (credentials) => {
    try {
      const res = await api.post("/auth/login", credentials);
      return res.data; // assuming backend returns { success: true, message: "", data: {} }
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Login failed");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  }
};

export default AuthService;
